import React from "react"
import FormSection from "./FormSection"
import NameInput from "./NameInput"
import DateInput from "./DateInput"
import PhoneNumberInput from "./PhoneNumberInput"
import EmailInput from "./EmailInput"
import AddressInput from "./AddressInput"
import PasswordInput from "./PasswordInput"
import HelperText from "./HelperText"
import TermsAndConditions from "./TermsAndConditions"
import FormFooterLinks from "./FormFooterLinks"
import FormSubmit from "./FormSubmit"

export default class FormElementsDemo extends React.Component {
	
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this)
	}

	render() {
		console.log('FormElementsDemo', this.props);

		return (
			<div style={{width: 420, margin: '0 auto'}}>
				<form className="FormElements">
					<h1>Create Your Account</h1>
					<FormSection title="Contact Information">
						<NameInput />
						<Label>Date of birth</Label>
						<DateInput months={this.props.months} />
						<PhoneNumberInput />
						<EmailInput />
					</FormSection>
					<FormSection title="Address">
						<AddressInput states={this.props.states} />
					</FormSection>
					<FormSection title="Password">
						<PasswordInput placeholder="Password" />
						<HelperText>Use 8 or more characters with a mix of letters, numbers &amp; symbols</HelperText>
						<PasswordInput placeholder="Confirm Password" />
					</FormSection>	
					<FormSection>
						<TermsAndConditions />
					</FormSection>
					<FormSection>	
						<FormSubmit />
					</FormSection>
					<FormFooterLinks left={{path: this.props.login_path, text: 'Already a member? Sign in'}}
													 right={{path: this.props.forgot_password_path, text: 'Forgot Password'}} />	
				</form>
			</div>
		);	
	}

	/**
	* Change handlers
	*/

	onChange() {

	}

}